import 'bootstrap/dist/css/bootstrap.min.css';
import { onValue, ref } from 'firebase/database';
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Typewriter } from "react-simple-typewriter";
import '../App.css';
import { db } from '../Firebase';

const Front = () => {
  const [totalFamilies, setTotalFamilies] = useState(0);
  const [totalMembers, setTotalMembers] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [allRegs, setAllRegs] = useState([]);
  const [filterState, setFilterState] = useState('');
  const [filterCity, setFilterCity] = useState('');
  const [filterMandir, setFilterMandir] = useState('');
  const [filterBlock, setFilterBlock] = useState('');
  const [filterAreaType, setFilterAreaType] = useState('');
  const [filterPanchayat, setFilterPanchayat] = useState('');
  const [filterUrbanArea, setFilterUrbanArea] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsVisible(true);

    const unsub = onValue(ref(db, 'registration'), snap => {
      if (!snap.exists()) { setTotalFamilies(0); setTotalMembers(0); setAllRegs([]); return; }
      const regs = Object.values(snap.val());
      let memCount = 0;
      regs.forEach(r => { if (r.members) memCount += Object.keys(r.members).length; });
      setTotalFamilies(regs.length);
      setTotalMembers(memCount);
      setAllRegs(regs);
    });

    return () => unsub();
  }, []);

  const stateOptions   = [...new Set(allRegs.map(r => r.basic?.state).filter(Boolean))].sort();
  const cityOptions    = [...new Set(allRegs.filter(r => !filterState || r.basic?.state === filterState).map(r => r.basic?.city).filter(Boolean))].sort();
  const blockOptions   = [...new Set(allRegs.filter(r => (!filterState || r.basic?.state === filterState) && (!filterCity || r.basic?.city === filterCity)).map(r => r.basic?.block).filter(Boolean))].sort();
  const areaTypeOptions = ['Urban', 'Rural'];
  const panchayatOptions = [...new Set(allRegs.filter(r => (!filterCity || r.basic?.city === filterCity) && (!filterBlock || r.basic?.block === filterBlock)).map(r => r.basic?.panchayat).filter(Boolean))].sort();
  const urbanAreaOptions = [...new Set(allRegs.filter(r => (!filterCity || r.basic?.city === filterCity) && (!filterBlock || r.basic?.block === filterBlock)).map(r => r.basic?.urbanArea).filter(Boolean))].sort();
  const mandirOptions  = [...new Set(allRegs.filter(r => (!filterState || r.basic?.state === filterState) && (!filterCity || r.basic?.city === filterCity)).map(r => r.basic?.Mandirtype).filter(Boolean))].sort();

  const filteredRows = allRegs.filter(r =>
    (!filterState    || r.basic?.state    === filterState) &&
    (!filterCity     || r.basic?.city     === filterCity) &&
    (!filterBlock    || r.basic?.block    === filterBlock) &&
    (!filterAreaType || r.basic?.areaType === filterAreaType) &&
    (!filterPanchayat || r.basic?.panchayat === filterPanchayat) &&
    (!filterUrbanArea || r.basic?.urbanArea === filterUrbanArea) &&
    (!filterMandir   || r.basic?.Mandirtype === filterMandir)
  );

  const filteredFamilies = filteredRows.length;
  const filteredMembers = filteredRows.reduce((s, r) => s + (r.members ? Object.keys(r.members).length : 0), 0);

  const cards = [
    {
      title: "परिवार का पंजीयन करे",
      desc: "अपने पूरे परिवार को जैन समग्र पोर्टल पर पंजीकृत करें।",
      img: "1.avif",
      link: "/registration",
      icon: "👨‍👩‍👧‍👦",
      color: "#213F6D",
    },
    {
      title: "जानकारी खोजें",
      desc: "नाम, मोबाइल नंबर, आईडी या आधार नंबर द्वारा खोजें",
      img: "2.avif",
      link: "/search",
      icon: "🔍",
      color: "#213F6D",
    },
    {
      title: "परिवार सदस्य पंजीयन",
      desc: "परिवार के नए सदस्य का पंजीयन एवं विवरण अपडेट करें।",
      img: "3.jpg",
      link: "/add-member",
      icon: "👤",
      color: "#213F6D",
    },
    {
      title: "विशिष्ठ पंजीयन",
      desc: "संत, विद्वान, संस्था, मंदिर एवं व्यवसायी का विशेष पंजीयन करें।",
      img: "4.jpeg",
      link: "/vishisht-panjikaran",
      icon: "🏅",
      color: "#213F6D",
    },
    {
      title: "जैन समग्र परिवार कार्ड डाउनलोड करे",
      desc: "डिजिटल परिवार कार्ड को मोबाइल या कंप्यूटर में सेव करें।",
      img: "4.jpeg",
      link: "/parivar-card",
      icon: "💳",
      color: "#213F6D",
    },
  ];

  return (
    <>
      {/* Hero Section */}
      <section
        className="hero-section d-flex align-items-center justify-content-center text-center position-relative"
        style={{
          background: "#F0F2F5",
          minHeight: "100vh"
        }}
      >
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : 50 }}
            transition={{ duration: 1, delay: 0.2 }}
            className="hero-content"
          >
            <div className="mb-4">
              <span className="badge px-4 py-2 mb-3" style={{
                background: "#213F6D",
                color: "white",
                fontSize: "16px",
                borderRadius: "50px"
              }}>
                🏛️ जैन समुदाय का डिजिटल प्लेटफॉर्म
              </span>
            </div>
            
            <h1
              className="display-4 fw-bold mb-4"
              style={{ 
                color: '#333333',
                lineHeight: "1.2",
                fontWeight: "700"
              }}
            >
              <Typewriter 
                words={[
                  "जैन समुदाय को सशक्त बनाना\nएक साथ, एक मंच पर"
                ]}
                loop={1}
                cursor
                cursorStyle="|"
                typeSpeed={80}
              />
            </h1>
            
            <p className="lead mb-5" style={{
              color: "#666666",
              fontSize: "1.4rem",
              maxWidth: "650px",
              margin: "0 auto",
              fontWeight: "500",
              lineHeight: "1.4"
            }}>
              डिजिटल युग में जैन परिवारों को जोड़ने का आधुनिक समाधान
            </p>
            
            <div className="hero-buttons d-flex flex-column flex-sm-row flex-wrap justify-content-center gap-3">
              <Link
                to="/registration"
                className="btn btn-lg px-4 py-3 fw-bold rounded-pill btn-primary"
                style={{ background: "#213F6D", color: "#FFFFFF", border: "none", textDecoration: "none", minWidth: "220px" }}
              >
                👨‍👩‍👧‍👦 परिवार पंजीयन करे
              </Link>

              <Link
                to="/add-member"
                className="btn btn-lg px-4 py-3 fw-bold rounded-pill btn-primary"
                style={{ background: "#213F6D", color: "#FFFFFF", border: "none", textDecoration: "none", minWidth: "220px" }}
              >
                👤 परिवार में सदस्य जोड़े
              </Link>

              <Link
                to="/vishisht-panjikaran"
                className="btn btn-lg px-4 py-3 fw-bold rounded-pill btn-primary"
                style={{ background: "#213F6D", color: "#FFFFFF", border: "none", textDecoration: "none", minWidth: "220px" }}
              >
                🏅 विशिष्ठ पंजीयन
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Support Section */}
      <motion.div
        className="py-5"
        style={{ background: "linear-gradient(135deg, #102A5C 0%, #1A365D 60%, #213F6D 100%)", position: "relative", overflow: "hidden" }}
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
      >
        <div style={{ position: "absolute", top: "-60px", right: "-60px", width: "220px", height: "220px", background: "rgba(39,174,150,0.18)", borderRadius: "50%", filter: "blur(40px)" }} />
        <div style={{ position: "absolute", bottom: "-40px", left: "-40px", width: "160px", height: "160px", background: "rgba(33,63,120,0.15)", borderRadius: "50%", filter: "blur(30px)" }} />
        <div className="container position-relative">
          <div className="row align-items-center gy-4">
            <div className="col-lg-7">
              <div className="d-flex align-items-center gap-4">
                <div style={{ width: "64px", height: "64px", background: "linear-gradient(135deg,#213F6D,#193264)", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 8px 24px rgba(33,63,120,0.4)", flexShrink: 0 }}>
                  <span style={{ fontSize: "1.8rem" }}>📞</span>
                </div>
                <div>
                  <span className="badge mb-2" style={{ background: "rgba(39,174,150,0.25)", color: "#5eead4", borderRadius: "50px", fontSize: "11px", padding: "4px 12px", border: "1px solid rgba(33,63,120,0.4)" }}>सहायता केंद्र</span>
                  <h4 className="text-white fw-bold mb-1" style={{ fontSize: "clamp(1.1rem,3vw,1.5rem)" }}>सहायता के लिए संपर्क करें</h4>
                  <p className="mb-0" style={{ color: "#FFFFFF", fontSize: "0.92rem" }}>पंजीयन, खोज या किसी भी समस्या के लिए हमारी टीम सदैव तैयार है।</p>
                </div>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="d-flex flex-column flex-sm-row gap-3 justify-content-lg-end">
                <a href="tel:+919425006497" className="btn fw-bold rounded-pill px-4 py-3 d-flex align-items-center gap-2" style={{ background: "white", color: "#213F6D", border: "2px solid #213F6D", fontSize: "1rem", textDecoration: "none" }}>
                  <span style={{ fontSize: "1.2rem" }}>📱</span>
                  <span>9425006497</span>
                </a>
                <a href="https://wa.me/919425006497" target="_blank" rel="noreferrer" className="btn fw-bold rounded-pill px-4 py-3 d-flex align-items-center gap-2" style={{ background: "white", color: "#333333", border: "2px solid #CCCCCC", fontSize: "1rem", textDecoration: "none" }}>
                  <span style={{ fontSize: "1.2rem" }}>💬</span>
                  <span>WhatsApp</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Services Section */}
      <div className="services-section py-5" style={{
        background: "white",
        position: "relative"
      }}>
        <div className="container">
          <motion.div 
            className="text-center mb-5"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="mb-3">
              <span className="badge px-4 py-2" style={{
                background: "#213F6D",
                color: "white",
                fontSize: "16px",
                borderRadius: "50px"
              }}>
                🛠️ हमारी सेवाएं
              </span>
            </div>
            <h2 className="display-5 fw-bold mb-3" style={{ color: "#333333" }}>
              आवश्यक सेवाएँ
            </h2>
            <p className="lead mb-0" style={{ color: "#666666", fontWeight: "500", fontSize: "1.2rem" }}>
              पंजीयन एवं कार्ड सुविधा - आपके लिए सरल और सुरक्षित
            </p>
          </motion.div>

          <div className="row g-4 justify-content-center">
            {cards.map((card, index) => (
              <div className="col-lg-4 col-md-6" key={index}>
                <motion.div
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                >
                  <Link
                    to={card.link}
                    className="text-decoration-none"
                  >
                    <motion.div
                      className="service-card h-100 rounded-4 overflow-hidden position-relative"
                      style={{
                        background: "white",
                        boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                        border: "1px solid #F3F4F6",
                        transition: "all 0.3s ease"
                      }}
                      whileHover={{
                        y: -5,
                        boxShadow: "0 8px 25px rgba(0,0,0,0.15)"
                      }}
                    >
                      <div 
                        className="card-header p-0 position-relative"
                        style={{
                          height: "150px",
                          background: "#213F6D",
                          overflow: "hidden"
                        }}
                      >
                        <div className="position-absolute top-50 start-50 translate-middle text-center">
                          <div className="mb-3">
                            <span className="display-4">{card.icon}</span>
                          </div>
                        </div>
                      </div>

                      <div className="card-body p-4 text-center">
                        <h5 className="fw-bold mb-3" style={{ color: "#333333", lineHeight: "1.3", fontSize: "1.1rem" }}>
                          {card.title}
                        </h5>
                        <p className="small mb-4" style={{ lineHeight: "1.5", color: "#666666", fontWeight: "400" }}>
                          {card.desc}
                        </p>
                        
                        <div className="d-flex justify-content-center">
                          <span 
                            className="btn btn-sm px-4 py-2 rounded-pill fw-semibold"
                            style={{
                              background: "#213F78",
                              color: "white",
                              border: "none",
                              fontSize: "12px"
                            }}
                          >
                            शुरू करें →
                          </span>
                        </div>
                      </div>
                    </motion.div>
                  </Link>
                </motion.div>
              </div>
            ))}
          </div>
        </div>
      </div>
      
      
      {/* Filter Table Section */}
      <div className="py-5" style={{ background: '#F0F2F5', borderTop: '2px solid #213F6D' }}>
       
        <div className="container">
          <div className="mb-4">
            <span className="badge px-3 py-2 mb-2" style={{ background: '#213F6D', color: 'white', borderRadius: '50px', fontSize: '13px' }}>📊 स्थान अनुसार आँकड़े</span>
            <h2 className="fw-bold mb-1" style={{ color: '#333333', fontSize: 'clamp(1.2rem, 3vw, 1.6rem)' }}>राज्य / शहर / मंदिर अनुसार परिवार एवं सदस्य संख्या</h2>
          </div>
           <div className="row g-3 mt-2">
            <div className="col-6">
              <div className="card border-0 shadow-sm text-center py-3" style={{ borderTop: '4px solid #213F6D', borderRadius: '12px' }}>
                <div style={{ fontSize: '1.8rem' }}>👨‍👩‍👧‍👦</div>
                <div className="fw-bold mt-1" style={{ color: '#213F6D', fontSize: '2rem', lineHeight: 1 }}>{filteredFamilies}</div>
                <small className="text-muted">परिवार</small>
              </div>
            </div>
            <div className="col-6">
              <div className="card border-0 shadow-sm text-center py-3" style={{ borderTop: '4px solid #213F6D', borderRadius: '12px' }}>
                <div style={{ fontSize: '1.8rem' }}>👥</div>
                <div className="fw-bold mt-1" style={{ color: '#213F6D', fontSize: '2rem', lineHeight: 1 }}>{filteredMembers}</div>
                <small className="text-muted">सदस्य</small>
              </div>
            </div>
          </div>

          {/* Filters */}
          <div className="row g-2 mb-4">
            
            <div className="col-12 col-md-4">
              <label className="form-label fw-semibold mb-1" style={{ fontSize: '0.82rem', color: '#333333' }}>🗺️ राज्य</label>
              <select className="form-select" value={filterState} onChange={e => { setFilterState(e.target.value); setFilterCity(''); setFilterBlock(''); setFilterAreaType(''); setFilterPanchayat(''); setFilterUrbanArea(''); setFilterMandir(''); }}>
                <option value="">सभी राज्य</option>
                {stateOptions.map(s => <option key={s} value={s}>{s}</option>)}
              </select>
            </div>
            <div className="col-12 col-md-4">
              <label className="form-label fw-semibold mb-1" style={{ fontSize: '0.82rem', color: '#333333' }}>🏙️ शहर</label>
              <select className="form-select" value={filterCity} onChange={e => { setFilterCity(e.target.value); setFilterBlock(''); setFilterAreaType(''); setFilterPanchayat(''); setFilterUrbanArea(''); setFilterMandir(''); }} disabled={!filterState}>
                <option value="">सभी शहर</option>
                {cityOptions.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>
            <div className="col-12 col-md-4">
              <label className="form-label fw-semibold mb-1" style={{ fontSize: '0.82rem', color: '#333333' }}>🔲 ब्लॉक</label>
              <select className="form-select" value={filterBlock} onChange={e => { setFilterBlock(e.target.value); setFilterPanchayat(''); setFilterUrbanArea(''); }} disabled={!filterCity}>
                <option value="">सभी ब्लॉक</option>
                {blockOptions.map(b => <option key={b} value={b}>{b}</option>)}
              </select>
            </div>
            <div className="col-12 col-md-4">
              <label className="form-label fw-semibold mb-1" style={{ fontSize: '0.82rem', color: '#333333' }}>🏘️ शहरी / ग्रामीण</label>
              <select className="form-select" value={filterAreaType} onChange={e => { setFilterAreaType(e.target.value); setFilterPanchayat(''); setFilterUrbanArea(''); }} disabled={!filterCity}>
                <option value="">सभी</option>
                <option value="Urban">शहरी</option>
                <option value="Rural">ग्रामीण</option>
              </select>
            </div>
            {filterAreaType === 'Rural' && (
              <div className="col-12 col-md-4">
                <label className="form-label fw-semibold mb-1" style={{ fontSize: '0.82rem', color: '#333333' }}>🌾 पंचायत</label>
                <select className="form-select" value={filterPanchayat} onChange={e => setFilterPanchayat(e.target.value)} disabled={!filterCity}>
                  <option value="">सभी पंचायत</option>
                  {panchayatOptions.map(p => <option key={p} value={p}>{p}</option>)}
                </select>
              </div>
            )}
            {filterAreaType === 'Urban' && (
              <div className="col-12 col-md-4">
                <label className="form-label fw-semibold mb-1" style={{ fontSize: '0.82rem', color: '#333333' }}>🏢 शहरी क्षेत्र</label>
                <select className="form-select" value={filterUrbanArea} onChange={e => setFilterUrbanArea(e.target.value)} disabled={!filterCity}>
                  <option value="">सभी क्षेत्र</option>
                  {urbanAreaOptions.map(u => <option key={u} value={u}>{u}</option>)}
                </select>
              </div>
            )}
            <div className="col-12 col-md-4">
              <label className="form-label fw-semibold mb-1" style={{ fontSize: '0.82rem', color: '#333333' }}>🕌 मंदिर</label>
              <select className="form-select" value={filterMandir} onChange={e => setFilterMandir(e.target.value)} disabled={!filterState}>
                <option value="">सभी मंदिर</option>
                {mandirOptions.map(m => <option key={m} value={m}>{m}</option>)}
              </select>
            </div>
          </div>

         
        </div>
      </div>

      <style>{`
        .hero-section {
          position: relative;
        }
        
        .service-card:hover {
          transform: translateY(-5px) !important;
        }
        
        .stats-card {
          transition: all 0.3s ease;
        }
        
        .stats-card:hover {
          background: rgba(255,255,255,0.2) !important;
        }
        
        @media (max-width: 768px) {
          .hero-section {
            min-height: 70vh !important;
          }
          
          .display-4 {
            font-size: 2rem !important;
          }
          
          .hero-buttons .btn {
            width: 100%;
          }
        }
      `}</style>
    </>
  );
};

export default Front;
